/**
 * Contenedor visual unificado para pantallas de auth / alta de empresa (tema 0E3).
 * Requerido por VerificarEmailEmpresa.js (import existente en HEAD).
 */
import React from 'react';
import BrandLogo from '../common/BrandLogo';
import StagingBanner from '../common/StagingBanner';

const AuthShell = ({
  eyebrow,
  title,
  subtitle,
  children,
  maxWidthClass = 'max-w-md',
  badge = null
}) => (
  <div className="relative flex min-h-screen flex-col items-center justify-center overflow-x-hidden overflow-y-auto e0e3-app-shell-bg px-4 py-8">
    <StagingBanner className="fixed top-0 left-0 right-0 z-50" />
    <div className={`relative z-10 w-full ${maxWidthClass} overflow-hidden rounded-2xl border border-white/12 bg-e0e3-surface/95 shadow-elevated ring-1 ring-white/10 backdrop-blur-md`}>
      <div className="h-1 w-full bg-gradient-to-r from-transparent via-e0e3-accent to-transparent" />
      <div className="px-8 py-10">
        <div className="mb-8 flex flex-col items-center text-center">
          <div className="mb-5 rounded-2xl bg-black/80 px-5 py-3 ring-1 ring-white/[0.12]">
            <BrandLogo
              className="flex h-20 w-auto items-center justify-center sm:h-24"
              showText={false}
              variant="full"
            />
          </div>
          {badge}
          {eyebrow ? (
            <p className="text-sm font-semibold uppercase tracking-wide text-e0e3-accent">{eyebrow}</p>
          ) : null}
          {title ? (
            <h1 className="mt-1 text-2xl font-extrabold tracking-tight text-e0e3-foreground sm:text-3xl">
              {title}
            </h1>
          ) : null}
          {subtitle ? (
            <p className="mt-2 text-sm leading-relaxed text-e0e3-muted">{subtitle}</p>
          ) : null}
        </div>
        {children}
      </div>
    </div>
  </div>
);

export default AuthShell;
